import { createBrowserRouter, Navigate } from "react-router-dom";
import WithHeaderLayout from "../components/WithHeaderLayout";
import WithoutHeaderLayout from "../components/WithoutHeaderLayout";

import HomeComponent from "../components/HomeComponent";
import DocumentView from "../pages/DocumentView";
import Login from "../pages/Login";
import PlatformSetupPage from "../pages/PlatformSetupPage";
import PasswordRecoveryPage from "../pages/PasswordRecoveryPage";
import AccountSecurityPage from "../pages/AccountSecurityPage";
import UploadDocuments from "../pages/UploadDocuments";
import AI_PDF_CONST from "../util/PdfAiConst";
import PrivateRoute from "../util/PrivateRoute";
import Holios from "../pages/Holios";
import HoliosUploadData from "../pages/HoliosUploadData";
import AIAutomation from "../pages/AIAutomation";
import AiLanding from "../pages/AiLanding";
import AIAutomationOptionA from "../pages/AIAutomationOptionA";
import AIAutomationOptionB from "../pages/AIAutomationOptionB";
import AIAutomation2 from "../pages/AIAutomation2";
import Communication from "../pages/Communication";
import AiComm from "../pages/AiComm";
import PdfToExl from "../pages/PdfToExl";
import VoiceCall from "../pages/VoiceCall";
import AdminOrgsPage from "../pages/AdminOrgsPage";
import AdminOrgUsersPage from "../pages/AdminOrgUsersPage";
import HomeComponent2 from "../components/HomeComponent2";
import CentralWhatsAppInbox from "../pages/admin/CentralWhatsAppInbox";
import WorkspaceDashboardPage from "../pages/admin/WorkspaceDashboardPage";
import TenantCreatePage from "../pages/admin/tenantcreatepage";
import TenantDetailPage from "../pages/admin/tenantdetailpage";
import TenantOnboardingPage from "../pages/admin/tenantonboardingpage";
import TenantProfilesListPage from "../pages/admin/tenantprofileslistpage";
import ServiceListPage from "../pages/admin/servicelistpage";
import AuditLogsPage from "../pages/admin/auditlogspage";
import OnboardingListPage from "../pages/admin/onboardinglistpage";
import AdminLayout from "../components/admin/AdminLayout";
import ErrorPage from "../pages/ErrorPage";
import PrivacyPolicy from "../pages/PrivacyPolicy";
import TermsOfService from "../pages/TermsOfService";
import DataDeletion from "../pages/DataDeletion";
import PublicTenantProfile from "../pages/PublicTenantProfile";
import PublicTenantDirectory from "../pages/PublicTenantDirectory";
import PublicBookingPage from "../pages/PublicBookingPage";

import ChatbotClientsPage from "../pages/admin/chatbot/ChatbotClientsPage";
import ChatbotClientCreatePage from "../pages/admin/chatbot/ChatbotClientCreatePage";
import ChatbotClientEditPage from "../pages/admin/chatbot/ChatbotClientEditPage";
import ChatbotClientUsersPage from "../pages/admin/chatbot/ChatbotClientUsersPage";
import ChatbotClientRolesPage from "../pages/admin/chatbot/ChatbotClientRolesPage";
import ChatbotClientUserCreatePage from "../pages/admin/chatbot/ChatbotClientUserCreatePage";
import ChatbotClientUserEditPage from "../pages/admin/chatbot/ChatbotClientUserEditPage";
import ChatbotClientDetailPage from "../pages/admin/chatbot/ChatbotClientDetailPage";
import ChatbotBusinessDetailPage from "../pages/admin/chatbot/ChatbotBusinessDetailPage";
import ChatbotEditPage from "../pages/admin/chatbot/ChatbotEditPage";
import ChatbotToolsPage from "../pages/admin/chatbot/ChatbotToolsPage";
import ChatbotToolEditorPage from "../pages/admin/chatbot/ChatbotToolEditorPage";
import CustomersPage from "../pages/admin/chatbot/CustomersPage";
import LeadsPage from "../pages/admin/chatbot/LeadsPage";
import PublicFormPage from "../pages/PublicFormPage";
import BotWorkspace, { BotWorkspaceLanding, LegacyBotConfigRedirect, LegacyBotsRedirect, LegacyCustomerWorkspaceRedirect, LegacyInboxRedirect } from "../components/admin/BotWorkspace";
import BotSchedulingPage from "../pages/admin/chatbot/BotSchedulingPage";
import BotHomePage from "../pages/admin/chatbot/BotHomePage";
import PrescriptionsPage from "../pages/admin/chatbot/PrescriptionsPage";

const adminRoute = (element) => <PrivateRoute element={<AdminLayout>{element}</AdminLayout>} />;
const router = createBrowserRouter([
  {
    element: <WithHeaderLayout />,
    errorElement: <ErrorPage />,
    children: [
      { path: "/account/security", element: <PrivateRoute element={<AccountSecurityPage />} /> },
      {
        path: AI_PDF_CONST.ROUTE.DOCUMENTS,
        element: <PrivateRoute element={<UploadDocuments />} />,
      },
      {
        path: AI_PDF_CONST.ROUTE.DOCUMENT_VIEW,
        element: <PrivateRoute element={<DocumentView />} />,
      },
      {
        path: AI_PDF_CONST.ROUTE.ADMIN_DASHBOARD,
        element: adminRoute(<WorkspaceDashboardPage />),
      },
      {
        path: "/bots/*",
        element: <LegacyBotsRedirect />,
      },
      {
        path: "/bot/*",
        element: <LegacyBotsRedirect />,
      },
      {
        path: AI_PDF_CONST.ROUTE.ADMIN_TENANTS_CREATE,
        element: adminRoute(<TenantCreatePage />),
      },
      {
        path: AI_PDF_CONST.ROUTE.ADMIN_TENANT_DETAIL,
        element: adminRoute(<TenantDetailPage />),
      },
      {
        path: AI_PDF_CONST.ROUTE.ADMIN_TENANT_DETAIL + "/meta-config",
        element: adminRoute(<BotWorkspace />),
        children: [{ index: true, element: <TenantDetailPage /> }],
      },
      {
        path: AI_PDF_CONST.ROUTE.ADMIN_TENANT_ONBOARDING,
        element: adminRoute(<TenantOnboardingPage />),
      },
      {
        path: AI_PDF_CONST.ROUTE.ADMIN_TENANT_PROFILES,
        element: adminRoute(<TenantProfilesListPage />),
      },
      {
        path: AI_PDF_CONST.ROUTE.ADMIN_SERVICES,
        element: adminRoute(<ServiceListPage />),
      },
      {
        path: AI_PDF_CONST.ROUTE.ADMIN_AUDIT_LOGS,
        element: adminRoute(<AuditLogsPage />),
      },
      {
        path: AI_PDF_CONST.ROUTE.ADMIN_ONBOARDING,
        element: adminRoute(<OnboardingListPage />),
      },
      {
        path: AI_PDF_CONST.ROUTE.HOLIOS,
        element: <Holios />,
      },
      {
        path: AI_PDF_CONST.ROUTE.HOLIOS_UPLOAD_DATA,
        element: <HoliosUploadData />,
      },
      {
        path: AI_PDF_CONST.ROUTE.AI_AUTOMATION,
        element: <AIAutomation />,
      },
      {
        path: AI_PDF_CONST.ROUTE.AI,
        element: <AiLanding />,
      },
      {
        path: AI_PDF_CONST.ROUTE.AI_A,
        element: <AIAutomationOptionA />,
      },
      {
        path: AI_PDF_CONST.ROUTE.AI_B,
        element: <AIAutomationOptionB />,
      },
      {
        path: AI_PDF_CONST.ROUTE.AI_AUTOMATION_2,
        element: <AIAutomation2 />,
      },
      {
        path: AI_PDF_CONST.ROUTE.COMMUNICATION,
        element: <Communication />,
      },
      {
        path: AI_PDF_CONST.ROUTE.AI_COMM,
        element: <AiComm />,
      },
      {
        path: AI_PDF_CONST.ROUTE.PDF_TO_EXL,
        element: <PdfToExl />,
      },
      {
        path: AI_PDF_CONST.ROUTE.VOICE_CALL,
        element: <PrivateRoute element={<VoiceCall />} />,
      },
      {
        path: "/chat",
        element: <PrivateRoute element={<Navigate to="/agents" replace />} />,
      },
      {
        path: "/whatsapp-inbox/:tenantId?/:conversationId?",
        element: <PrivateRoute element={<LegacyInboxRedirect />} />,
      },
      {
        path: AI_PDF_CONST.ROUTE.ADMIN_ORGS,
        element: <PrivateRoute element={<AdminOrgsPage />} />,
      },
      {
        path: AI_PDF_CONST.ROUTE.ADMIN_ORG_USERS,
        element: <PrivateRoute element={<AdminOrgUsersPage />} />,
      },
      
      {
        path: "/clients",
        element: adminRoute(<ChatbotClientsPage />),
      },
      {
        path: "/customers",
        element: adminRoute(<Navigate to="/agents" replace />),
      },
      {
        path: "/agents",
        element: adminRoute(<BotHomePage />),
      },
      {
        path: "/bot-home",
        element: <PrivateRoute element={<Navigate to="/agents" replace />} />,
      },
      {
        path: "/clients/new-client",
        element: adminRoute(<ChatbotClientCreatePage />),
      },
      {
        path: "/clients/:clientId/edit",
        element: adminRoute(<ChatbotClientEditPage />),
      },
      {
        path: "/clients/:clientId/users/new-user",
        element: adminRoute(<ChatbotClientUserCreatePage />),
      },
      {
        path: "/clients/:clientId/users/:userId/edit",
        element: adminRoute(<ChatbotClientUserEditPage />),
      },
      {
        path: "/clients/:clientId/users",
        element: adminRoute(<ChatbotClientUsersPage />),
      },
      {
        path: "/clients/:clientId/roles",
        element: adminRoute(<ChatbotClientRolesPage />),
      },
      {
        path: "/clients/:clientId/tools",
        element: adminRoute(<ChatbotToolsPage />),
      },
      {
        path: "/clients/:clientId/tools/new",
        element: adminRoute(<ChatbotToolEditorPage />),
      },
      {
        path: "/clients/:clientId/tools/:toolId",
        element: adminRoute(<ChatbotToolEditorPage />),
      },
      {
        path: "/clients/:clientId",
        element: adminRoute(<ChatbotClientDetailPage />),
      },
      {
        path: "/clients/:clientId/new-bot",
        element: adminRoute(<ChatbotClientDetailPage />),
      },
      {
        path: "/agents/:businessId",
        element: adminRoute(<BotWorkspace />),
        children: [
          { index: true, element: <BotWorkspaceLanding /> },
          { path: "edit", element: <ChatbotEditPage /> },
          { path: "agent-config", element: <ChatbotBusinessDetailPage /> },
          { path: "bot-config", element: <LegacyBotConfigRedirect /> },
          { path: "forms", element: <LegacyCustomerWorkspaceRedirect /> },
          { path: "customers", element: <CustomersPage /> },
          { path: "customers/:customerId", element: <CustomersPage /> },
          { path: "prescriptions", element: <PrescriptionsPage /> },
          { path: "prescriptions/:customerId", element: <PrescriptionsPage /> },
          { path: "prescriptions/:customerId/:prescriptionId", element: <PrescriptionsPage /> },
          { path: "leads", element: <LeadsPage /> },
          { path: "leads/:leadId", element: <LeadsPage /> },
          { path: "inbox/:conversationId?", element: <CentralWhatsAppInbox /> },
          { path: "appointments", element: <LegacyCustomerWorkspaceRedirect /> },
          { path: "providers", element: <BotSchedulingPage section="providers" /> },
          { path: "services", element: <BotSchedulingPage section="services" /> },
          { path: "booking-settings", element: <BotSchedulingPage section="settings" /> },
          { path: "notifications", element: <BotSchedulingPage section="notifications" /> },
          { path: "schedulers", element: <BotSchedulingPage section="schedulers" /> },
        ],
      },
      { path: "/privacy", element: <PrivacyPolicy /> },
      { path: "/terms", element: <TermsOfService /> },
      { path: "/data-deletion", element: <DataDeletion /> },
    ],
  },
  {
    element: <WithoutHeaderLayout />,
    errorElement: <ErrorPage />,
    children: [
      { path: AI_PDF_CONST.ROUTE.ROOT, element: <HomeComponent /> },
      { path: AI_PDF_CONST.ROUTE.HOME, element: <HomeComponent /> },
      { path: AI_PDF_CONST.ROUTE.HOME2, element: <HomeComponent2 /> },
      { path: AI_PDF_CONST.ROUTE.LOGIN, element: <Login /> },
      { path: "/setup", element: <PlatformSetupPage /> },
      { path: "/forgot-password", element: <PasswordRecoveryPage /> },
      { path: "/reset-password", element: <PasswordRecoveryPage purpose="reset" /> },
      { path: "/set-password", element: <PasswordRecoveryPage purpose="setup" /> },
      { path: AI_PDF_CONST.ROUTE.PUBLIC_TENANT_PROFILE, element: <PublicTenantProfile /> },
      { path: "/public/:slug/registration", element: <PublicTenantProfile registration /> },
      { path: "/public/:slug", element: <PublicTenantProfile /> },
      { path: AI_PDF_CONST.ROUTE.PUBLIC_TENANT_DIRECTORY, element: <PublicTenantDirectory /> },
      { path: "/book/:botId", element: <PublicBookingPage /> },
      { path: "/forms/:token", element: <PublicFormPage /> },
    ],
  },
]);

export default router;
